import { NavLink, useNavigate } from 'react-router-dom';
import { useAdminStore } from '@/lib/store';

interface NavItem {
  to: string;
  label: string;
  icon: string;
  /** 정확 일치 매칭 (대시보드 루트용) */
  end?: boolean;
}

const NAV_ITEMS: NavItem[] = [
  { to: '/dashboard', label: '대시보드', icon: '▣' },
  { to: '/users', label: '사용자', icon: '◔' },
  { to: '/monitoring', label: '모니터링', icon: '◉' },
  { to: '/database', label: 'DB', icon: '▤' },
  { to: '/audit', label: '감사 로그', icon: '☰' },
];

/** 좌측 고정 네비게이션 사이드바 */
export default function Sidebar() {
  const navigate = useNavigate();
  const logout = useAdminStore((s) => s.logout);

  const handleLogout = () => {
    logout();
    navigate('/login', { replace: true });
  };

  return (
    <aside className="sidebar">
      <div className="sidebar__brand">
        <span className="sidebar__logo">코</span>
        <span>코메 관리자</span>
      </div>

      <nav className="sidebar__nav">
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) => `sidebar__item${isActive ? ' is-active' : ''}`}
          >
            <span className="sidebar__item-icon" aria-hidden>
              {item.icon}
            </span>
            {item.label}
          </NavLink>
        ))}
      </nav>

      <div className="sidebar__footer">
        <button className="sidebar__item" onClick={handleLogout}>
          <span className="sidebar__item-icon" aria-hidden>
            ⎋
          </span>
          로그아웃
        </button>
      </div>
    </aside>
  );
}
